import isEmpty from "lodash-es/isEmpty";

export const COMMUNITY_LINK = "https://community.nextwork.org/c/i-have-a-question?automatic_login=true";
export const COMMUNITY_LINK_ASK =
  "https://community.nextwork.org/c/i-have-a-question?automatic_login=true&utm_source=app&utm_campaign=ask";
export const COMMUNITY_LINK_WITH_ERROR_UTM =
  "https://community.nextwork.org/c/i-have-a-question?automatic_login=true&utm_source=app&utm_campaign=server_error";
export const COMMUNITY_LINK_PROJECTS_PAGE =
  "https://community.nextwork.org/c/all-aws-projects?automatic_login=true&utm_source=app&utm_campaign=projects";

export const PROJECT_DOCUMENT_LINK = (projectId: string, user_nickname: string | undefined) => {
  const baseURL = `/projects/${projectId}/document.html`;

  if (!isEmpty(user_nickname)) {
    return `/${user_nickname}${baseURL}`;
  }

  return baseURL;
};
